import { useEffect } from 'react';
import { localStorageHyperDashboardTools } from '../utils/tools/localStorageHyperDashboardTools';

export const useLocalStorage = () => {

  useEffect(() => {
    if(!global.__ENV__.EXPLICIT_PRODUCTION) {
      if(!localStorageHyperDashboardTools.checkIfAllPropsInSettings()) {
        localStorageHyperDashboardTools.setInitialSettings();
      }
    }
  }, [  ]);
  const setItem = <T>(key: string, value: T) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.log('Error occurred while setting the key in localStorage');

    }
  };

  const getItem = (key: string) => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : undefined;
    } catch (error) {
      console.log('Error occurred while getting the key from localStorage');
    }
  }

  const removeItem = (key: string) => {
    try {
      window.localStorage.removeItem(JSON.stringify(key))
    } catch (error) {
      console.log('Error occurred while removing the key from localStorage');
    }
  }

  return { setItem, getItem, removeItem }
}